import { LOCAL_STORAGE, getDataSession } from "helper/session";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router";
import { ACTION_ALLOW, KEY_ROLE_BIZZ_UAA } from "./constant";
import { useTranslation } from "react-i18next";
import React, { useMemo } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children, roles, pathRouter = null }) => {
  const location = useLocation();
  const roleCurrent = getDataSession(LOCAL_STORAGE, KEY_ROLE_BIZZ_UAA);
  const listPermission = useSelector((state) => state.userData.listMenu);

  const { t } = useTranslation("uaa");

  const { isAuthor, pmsAction } = useMemo(() => {
    if (_.isNil(roles))
      return {
        isAuthor: true,
        pmsAction: ACTION_ALLOW,
      };

    const { code: key } = Object(roleCurrent) || {};

    const ACTION = _.reduce(
      ACTION_ALLOW,
      function (result, value, key) {
        result[key] = false;
        return result;
      },
      {}
    );

    const pmsAction = _.assign(ACTION, _.get(roles, key));

    const pathUrl = location?.pathname.replace(/\d+/g, '{param}')

    return {
      isAuthor: !!pathRouter ? listPermission.some((item) =>
        item.endpoint.includes(pathRouter.replace(/^\//, ""))
      ) : listPermission.some((item) =>
        item.endpoint.includes(pathUrl.replace(/^\//, ""))
      ),
      pmsAction,
    };
  }, [listPermission, location?.pathname, pathRouter, roleCurrent, roles]);

  const isAuthenticated = getDataSession(LOCAL_STORAGE, "isLogin");

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (!isAuthor) {
    return <>{t("message.permission")}</>;
  }
  return React.cloneElement(children, { ...children.props, pmsAction });
};

PrivateRoute.propTypes = {
  roles: PropTypes.object,
  children: PropTypes.element.isRequired,
};

export default PrivateRoute;
